<template>
    <v-layout column style="gap:4px" v-if="shows">
        <v-btn v-bind="{ loading, outlined: disabled }" color="primary" @click="cash">
            <span>{{ disabled ? "충전완료" : "충전하기" }}</span>
        </v-btn>
    </v-layout>
    <span v-else> - </span>
</template>

<script>
import api from "@/api";
import { mapActions } from "vuex";
import { initUserExchangeBulk } from "@/assets/lib";

export default {
    props: {
        /** @type {import('vue/types/umd').PropType<import('@/assets/lib').UserExchangeBulk>} */
        value: { type: Object, default: initUserExchangeBulk },
    },
    data: () => ({
        /** @type {import('@/assets/lib').UserExchangeBulk} */
        form: initUserExchangeBulk(),

        loading: false,
    }),
    computed: {
        shows() {
            return !this.form.gifted && !this.form.undone;
        },
        disabled() {
            return this.form.exchanges_toCash.length < 1;
        },
    },
    methods: {
        ...mapActions(["getUser"]),

        sync() {
            this.form = initUserExchangeBulk(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        async cash() {
            if (this.disabled) {
                this.$router.push("/mypage/cashes/inquiry");
                return;
            }

            let { amount } = this.form;
            let go = confirm(`${amount.format()}원을 나누리 캐시로 바로 충전하시겠습니까?`);
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { bulk } = await api.v1.me.exchanges.bulks.cash.postExec({ _id: this.form._id });

                this.form = initUserExchangeBulk(bulk);

                this.getUser();

                let message = "";

                let items_success = this.form.exchanges.filter((item) => item.cashed && !item.failedToCash);
                let successAmount = items_success.reduce((sum, item) => sum + item.amount, 0);

                let items_failure = this.form.exchanges.filter((item) => !item.cashed || item.failedToCash);
                if (0 < items_failure.length) {
                    let totalCount = this.form.exchanges.length;
                    let successCount = items_success.length;

                    message = `${totalCount.format()}건 중 ${successCount.format()}건 충전하기에 성공했습니다.`;
                } else {
                    message = `나누리 캐시 충전에 성공했습니다.`;
                }

                message += `\n\n충전 금액: ${successAmount.format()}원\n\n자세한 내용은 ‘마이페이지 > 나누리캐시 > 캐시내역’에서 확인하실 수 있습니다.`;

                alert(message);
            } finally {
                this.loading = false;
            }
            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
